import { UserCard } from './user_card';
import { Certifications } from './certifications';
import { VoteHistory, VoteHistoryDataType } from './vote_history';
import { Flex } from '@chakra-ui/react';

export type SidebarDataType = {
   userCardData: any;
   certData?: any;
   voteHistoryData?: VoteHistoryDataType;
};

export function Sidebar({ userCardData, certData, voteHistoryData }: SidebarDataType) {
   const displayCertificationsModule = certData ? true : false;
   const displayVoteHistoryModule = voteHistoryData ? true : false;

   return (
      <Flex direction="column" align="flex-start">
         <UserCard {...userCardData} />
         {displayCertificationsModule && <Certifications {...certData} />}
         {/* @ts-expect-error TS(2322) FIXME: Type '{ username?: string | undefined; votesByUser... Remove this comment to see the full error message */}
         {displayVoteHistoryModule && <VoteHistory {...voteHistoryData} />}
      </Flex>
   );
}
